// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loading[data-v-7596f830] {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n", ""]);
// Exports
module.exports = exports;
